
import { BlogSection } from '@/types/blog';

export const naechsterSchrittSection: BlogSection = {
  id: 'naechster-schritt',
  title: 'Ihr nächster Schritt zur finanziellen Selbstbestimmung',
  content: `
    <p>
      Coaching ist kein Trend, sondern eine <strong>essenzielle Methode</strong> für persönliche und berufliche Entwicklung. 
      Ob im klassischen Business-Coaching oder im Finanzcoaching – die Prinzipien bleiben dieselben: 
      Zuhören, Fragen stellen, begleiten und Menschen befähigen, ihre eigenen Lösungen zu finden.
    </p>
    
    <p>
      Wenn Sie herausfinden möchten, wie Coaching Ihnen dabei helfen kann, finanziell selbstbestimmt zu handeln 
      und bewusste Entscheidungen zu treffen – sei es in einer entspannten Outdoor-Session am Rothsee in der 
      Metropolregion Nürnberg oder in einem persönlichen Gespräch unabhängig vom Standort – dann nehmen Sie Kontakt auf.
    </p>
    
    <div class="my-8 p-6 border-l-4 border-primary/80 bg-joerg-50 rounded-r-lg">
      <p class="mb-3 font-medium text-joerg-800">Bereit für Ihren persönlichen nächsten Schritt?</p>
      <p class="text-joerg-600 text-sm">
        Entdecken Sie, wie Finanzcoaching Ihre persönliche Entwicklung unterstützen kann.
        <a href="/kontakt" class="inline-flex items-center ml-2 text-primary hover:underline font-medium">Kontakt aufnehmen</a>
      </p>
    </div>
  `
};
